import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DrugDetails } from 'src/app/models/drug-details';
import { DrugSearchAlternatives } from 'src/app/models/drug-search-alternatives';
import { DrugSearchCriteria } from 'src/app/models/drug-search-criteria';
import { DrugSearchDetailData } from 'src/app/models/drug-search-detail-data';
import { DrugSearchPATabAndOtherTabDetails } from 'src/app/models/drug-search-patab-and-other-tab-details';
import { DrugSearchQLTabDetails } from 'src/app/models/drug-search-qltab-details';
import { DrugSearchSTTabDetails } from 'src/app/models/drug-search-sttab-details';
import { DrugSearchTCCDetails } from 'src/app/models/drug-search-tcc-details';
import { PlanDetails } from 'src/app/models/plan-details';
import { ValidMatchingEntry } from 'src/app/models/valid-matching-entry';
import { DrugSearchURLService } from 'src/app/services/drug-search-url.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-drug-search-details',
  templateUrl: './drug-search-details.component.html',
  styleUrls: ['./drug-search-details.component.scss']
})
export class DrugSearchDetailsComponent implements OnInit {

  
  drugSearchCriteria = new DrugSearchCriteria();
  planDetails: PlanDetails;
  validMatchingEntryList = new Array<ValidMatchingEntry>();
  @ViewChild('alternativesmodal') alternativesmodal: ElementRef;
  closeResult: string;
  showAlert: boolean;
  alertMessage: string;
  drugSearchDetailData = new DrugSearchDetailData();
  showDugSearchDetailData: boolean;
  displayAlternativesButton: boolean;
  showAlternativesPopUp: boolean;
  flTabDetails = new Array<DrugSearchPATabAndOtherTabDetails>();
  stTabDetails: Array<DrugSearchSTTabDetails>;
  qlTabDetails: Array<DrugSearchQLTabDetails>;
  paTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;

  acaTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  ageTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  code1TabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  dlTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  exdTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  fffTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  gapTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  genderTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  hcTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  hiTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  ispTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  laTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  laoTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  moTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  maintanaceTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  npdTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  ndsTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  oacTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  otherTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  otcTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  partbTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  pgTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  pdTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  rebateTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  saoTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  spTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  vbidTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  bhrsTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  fabTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  mabTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  pdcTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  siTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  partdTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  zdvTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;


  drugSearchAlternativesList = new Array<DrugSearchAlternatives>();
  tccDetails = new Array<DrugSearchTCCDetails>();
  tccAlternativeDetails = new Array<DrugSearchTCCDetails>();
  tccDetail = new DrugSearchTCCDetails();

  labelName: string;
  drugDetails: DrugDetails;
  labelIndex: number;
  showError: boolean;
  showAlertMessage: boolean;
  subs = new SubSink();
  drugNotCovered: string;
  drugExcluded: string;
  noAlternativesMessage: string;
  drugNonFormulary: string;
  noResultsFound: string;
  noSearchResultsFound: string;
  showAlternativeAlertMessage: boolean;

  validMatchingEntry = new ValidMatchingEntry();
  showNoSearchResultsFound: boolean;
  arrowFlagPA: boolean = true;
  arrowFlagQL: boolean = true;
  arrowFlagST: boolean = true;
  arrowFlagACA: boolean = true;
  arrowFlagAge: boolean = true;
  arrowFlagBhrs: boolean = true;
  arrowFlagcode1: boolean = true;
  arrowFlagdl: boolean = true;
  arrowFlagexd: boolean = true;
  arrowFlagfff: boolean = true;
  arrowFlagfab: boolean = true;
  arrowFlaggap: boolean = true;
  arrowFlaggender: boolean = true;
  arrowFlaghc: boolean = true;
  arrowFlaghi: boolean = true;
  arrowFlagisp: boolean = true;
  arrowFlagla: boolean = true;
  arrowFlaglao: boolean = true;
  arrowFlagmo: boolean = true;
  arrowFlagmaintanace: boolean = true;
  arrowFlagmab: boolean = true;
  arrowFlagnpd: boolean = true;
  arrowFlagnds: boolean = true;
  arrowFlagoac: boolean = true;
  arrowFlagother: boolean = true;
  arrowFlagotc: boolean = true;
  arrowFlagpartb: boolean = true;
  arrowFlagpd: boolean = true;
  arrowFlagpg: boolean = true;
  arrowFlagpdc: boolean = true;
  arrowFlagrebate: boolean = true;
  arrowFlagsao: boolean = true;
  arrowFlagsp: boolean = true;
  arrowFlagvbid: boolean = true;




  @Input('searchByDrugNameMap') searchByDrugNameMap: any;
  @Input('isBrandOrGeneric') isBrandOrGeneric: string;
  @ViewChild("printComp") printComp: ElementRef;
  @ViewChild("printErrorComp") printErrorComp: ElementRef;
  searchByLabelNameText: string;

  scrolled: boolean;
  limit = 20;
  offSet = 0;
  stopScrollApiCall: boolean;
  alternativeErrorMessage: boolean;

  @Input('drugSearchDetail') drugSearchDetail: DrugSearchDetailData;
  @Input('pIndex') pIndex: String;
  idState: any;
  rowqlcount: any;


  constructor(
    private _drugSearchURLService: DrugSearchURLService,
    private modalService: NgbModal,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.showAlert = false;
    this.planDetails = this._drugSearchURLService.planDetails;
    this.noAlternativesMessage = this._drugSearchURLService.messageKeyValueMap.get('ERR00510');
    this.getDrugSearchDetailData(this.drugSearchDetail);
  }

  expandTreeLeaf(i) {
    document.getElementById('label-' + i).classList.toggle('active');
    document.getElementById('brand-' + i).classList.toggle('fa-angle-down');
  }


  open(content) {
    this.modalService.open(content, { size: 'lg' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  closeAlert() {
    this.showAlert = false;
  }

  getDrugSearchDetailData(drugSearchDetailData: DrugSearchDetailData) {
    console.log(drugSearchDetailData);
      this.drugSearchDetailData = drugSearchDetailData
      this.drugDetails = this.drugSearchDetailData.drugDetails;
      var validMatchingEntry = this.drugSearchDetailData.drugSearchMatchingEntry;

      if (validMatchingEntry.druglabelNameText) {
        this.labelName = validMatchingEntry.druglabelNameText;
      } else {
        this.labelName = validMatchingEntry.labelName;
      }

      this.flTabDetails = this.drugSearchDetailData.flTabDetails;
      this.stTabDetails = this.drugSearchDetailData.stTabDetails;
      this.paTabDetails = this.drugSearchDetailData.paTabDetails;
      this.qlTabDetails = this.drugSearchDetailData.qlTabDetails;

      this.acaTabDetails = this.drugSearchDetailData.acaTabDetails;
      this.ageTabDetails = this.drugSearchDetailData.ageTabDetails;
      this.code1TabDetails = this.drugSearchDetailData.code1TabDetails;
      this.dlTabDetails = this.drugSearchDetailData.dlTabDetails;
      this.exdTabDetails = this.drugSearchDetailData.exdTabDetails;
      this.fffTabDetails = this.drugSearchDetailData.fffTabDetails;
      this.gapTabDetails = this.drugSearchDetailData.gapTabDetails;
      this.genderTabDetails = this.drugSearchDetailData.genderTabDetails;
      this.hcTabDetails = this.drugSearchDetailData.hcTabDetails;

      this.hiTabDetails = this.drugSearchDetailData.hiTabDetails;
      this.ispTabDetails = this.drugSearchDetailData.ispTabDetails;
      this.laTabDetails = this.drugSearchDetailData.laTabDetails;
      this.laoTabDetails = this.drugSearchDetailData.laoTabDetails;
      this.moTabDetails = this.drugSearchDetailData.moTabDetails;
      this.maintanaceTabDetails = this.drugSearchDetailData.maintanaceTabDetails;
      this.npdTabDetails = this.drugSearchDetailData.npdTabDetails;
      this.ndsTabDetails = this.drugSearchDetailData.ndsTabDetails;

      this.oacTabDetails = this.drugSearchDetailData.oacTabDetails;
      this.otherTabDetails = this.drugSearchDetailData.otherTabDetails;
      this.otcTabDetails = this.drugSearchDetailData.otcTabDetails;
      this.partbTabDetails = this.drugSearchDetailData.partbTabDetails;
      this.pdTabDetails = this.drugSearchDetailData.pdTabDetails;
      this.pgTabDetails = this.drugSearchDetailData.pgTabDetails;
      this.rebateTabDetails = this.drugSearchDetailData.rebateTabDetails;
      this.saoTabDetails = this.drugSearchDetailData.saoTabDetails;
      this.spTabDetails = this.drugSearchDetailData.spTabDetails;
      this.vbidTabDetails = this.drugSearchDetailData.vbidTabDetails;
      this.fabTabDetails = this.drugSearchDetailData.fabTabDetails;
      this.mabTabDetails = this.drugSearchDetailData.mabTabDetails;
      this.bhrsTabDetails = this.drugSearchDetailData.bhrsTabDetails;
      this.pdcTabDetails = this.drugSearchDetailData.pdcTabDetails;
      this.siTabDetails=this.drugSearchDetailData.siTabDetails;
      this.partdTabDetails=this.drugSearchDetailData.partdTabDetails;
      this.zdvTabDetails=this.drugSearchDetailData.zdvTabDetails;

      this.modalService.dismissAll();
      this.showDugSearchDetailData = true;
      this.displayAlternativesButton = true;
      this.changeDetector.detectChanges();
      if (this.flTabDetails.length === 0) {
        this.showError = true; 
        this.changeDetector.detectChanges();
      };
  }

  private getDismissReason(reason: any) { }

  expandSTTreeLeaf(i, stTabDetail, flag) {
    if (stTabDetail.urlSTProgramDisplayCode !== 'Z') {
      document.getElementById(this.pIndex+"-"+'stDetailMem-' + i).classList.toggle('active');
    }
    
   //  document.getElementById(this.pIndex+"-"+'stDetail-' + i).classList.toggle('fa-angle-down');
  //  if(flag){
  //     document.getElementById(this.pIndex+"-"+'stDetail-' + i).innerHTML = 'keyboard_arrow_down';
  //   }else{
  //     document.getElementById(this.pIndex+"-"+'stDetail-' + i).innerHTML = 'keyboard_arrow_right';
  //   }

  
  if(this.pIndex+"-"+'stDetail-' + i == this.pIndex+"-"+'stDetail-' + 0){

    const idQl = document.getElementById(this.pIndex+"-"+'stDetail-' + i);
    console.log(idQl.innerHTML);
    if(idQl.innerHTML.trim() == 'keyboard_arrow_right'){
      document.getElementById(this.pIndex+"-"+'stDetail-' + i).innerHTML = 'keyboard_arrow_down';

    }else{
      document.getElementById(this.pIndex+"-"+'stDetail-' + i).innerHTML = 'keyboard_arrow_right';
    }

  }else{

    
 const idQl2 = document.getElementById(this.pIndex+"-"+'stDetail-' + i);
 console.log(idQl2.innerHTML);
    if(idQl2.innerHTML.trim() == 'keyboard_arrow_right'){
      document.getElementById(this.pIndex+"-"+'stDetail-' + i).innerHTML = 'keyboard_arrow_down';
    }else{
      document.getElementById(this.pIndex+"-"+'stDetail-' + i).innerHTML = 'keyboard_arrow_right';
    }

  }

   this.arrowFlagST = !flag;

  }

  expandOtherTreeLeaf(i, otherType, tabDetails, flag) {
    if (tabDetails.urlDisplayCode == '1') {
      document.getElementById(this.pIndex+"-"+otherType + 'DetailMem-' + i).classList.toggle('active');
    }

    
    const idQl3 = document.getElementById(this.pIndex+"-"+otherType + 'Detail-' + i);
    console.log(idQl3.innerHTML);
    if(idQl3.innerHTML.trim() == 'keyboard_arrow_right'){
      document.getElementById(this.pIndex+"-"+otherType + 'Detail-' + i).innerHTML = 'keyboard_arrow_down';
    }else{
      document.getElementById(this.pIndex+"-"+otherType + 'Detail-' + i).innerHTML = 'keyboard_arrow_right';
    }
  }

  expandPATreeLeaf(i, paTabDetail, flag) {
     
   const idQl2 = document.getElementById(this.pIndex+"-"+'paDetail-' + i);
   console.log(idQl2.innerHTML);
      if(idQl2.innerHTML.trim() == 'keyboard_arrow_right'){
        document.getElementById(this.pIndex+"-"+'paDetail-' + i).innerHTML = 'keyboard_arrow_down';
      }else{
        document.getElementById(this.pIndex+"-"+'paDetail-' + i).innerHTML = 'keyboard_arrow_right';
      }
  
    this.arrowFlagPA = !flag;

    if (paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3') {
      document.getElementById(this.pIndex+"-"+'offLabelUses-' + i).classList.toggle('active');
      document.getElementById(this.pIndex+"-"+'exclusionCriteria-' + i).classList.toggle('active');
      document.getElementById(this.pIndex+"-"+'requiredMedicalInformation-' + i).classList.toggle('active');
      document.getElementById(this.pIndex+"-"+'ageRestrictions-' + i).classList.toggle('active');
      document.getElementById(this.pIndex+"-"+'prescriberRestrictions-' + i).classList.toggle('active');
      document.getElementById(this.pIndex+"-"+'coverageDuration-' + i).classList.toggle('active');
      document.getElementById(this.pIndex+"-"+'otherCriteria-' + i).classList.toggle('active');

      if (paTabDetail.lobId == 6) {
        document.getElementById(this.pIndex+"-"+'paIndicator-' + i).classList.toggle('active');
        document.getElementById(this.pIndex+"-"+'partbPreReqCode-' + i).classList.toggle('active');
      }
    }

    if (paTabDetail.urlDisplayCode == '2' || paTabDetail.urlDisplayCode == '3') {
      document.getElementById(this.pIndex+"-"+'pamemberMessaging-' + i).classList.toggle('active');
    }
  }

  expandqlTreeLeaf(i, qlTabDetail,flag) {
 
    console.log("flag", flag);
    console.log("qlTabDetail", qlTabDetail);
    console.log("i", i);

    if(this.pIndex+"-"+'qlDetail-' + i == this.pIndex+"-"+'qlDetail-' + 0){

      const idQl = document.getElementById(this.pIndex+"-"+'qlDetail-' + i);
      console.log(idQl.innerHTML);
      if(idQl.innerHTML == 'keyboard_arrow_right'){
        document.getElementById(this.pIndex+"-"+'qlDetail-' + i).innerHTML = 'keyboard_arrow_down';
  
      }else{
        document.getElementById(this.pIndex+"-"+'qlDetail-' + i).innerHTML = 'keyboard_arrow_right';
      }

    }else{

      
   const idQl2 = document.getElementById(this.pIndex+"-"+'qlDetail-' + i);
   console.log(idQl2.innerHTML);
      if(idQl2.innerHTML == 'keyboard_arrow_right'){
        document.getElementById(this.pIndex+"-"+'qlDetail-' + i).innerHTML = 'keyboard_arrow_down';
      }else{
        document.getElementById(this.pIndex+"-"+'qlDetail-' + i).innerHTML = 'keyboard_arrow_right';
      }

    }
    
    console.log("arrowFlagQL", this.arrowFlagQL);
    console.log("flag", flag);

    this.arrowFlagQL = !flag;
    console.log("arrowFlagQL", this.arrowFlagQL);


 //   this.idState = state;
    if (qlTabDetail.urlQLProgramDisplayCode == '1') {
      document.getElementById(this.pIndex+"-"+'quantityLimitAmount-' + i).classList.toggle('active');
    }
    if (qlTabDetail.urlQLProgramDisplayCode == '2') {
      document.getElementById(this.pIndex+"-"+'qlmemberMessaging-' + i).classList.toggle('active');
    }
    if (qlTabDetail.urlQLProgramDisplayCode == '3') {
      document.getElementById(this.pIndex+"-"+'quantityLimitAmount-' + i).classList.toggle('active');
      document.getElementById(this.pIndex+"-"+'qlmemberMessaging-' + i).classList.toggle('active');
    }
  }

  printComponent() {
    this.expandOrCollapse('BeforePrint');
    window.print();
    this.expandOrCollapse('AfterPrint');
  }

  expandOrCollapse(beforeOrAfter) {

    if (this.stTabDetails != null && this.stTabDetails.length > 0) {
      for (let i = 0; i < this.stTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'stDetailMem-' + i).classList.contains('active')) {
          this.expandSTTreeLeaf(i, this.stTabDetails[i],true);
        }
      }
    }

    if (this.paTabDetails != null && this.paTabDetails.length > 0) {
      let paCount = 0;
      for (let paTabDetail of this.paTabDetails) {
        if (paTabDetail.urlDisplayCode == '1') {
          if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'offLabelUses-' + paCount).classList.contains('active')) {
            this.expandPATreeLeaf(paCount, paTabDetail,true);
          }
        } else if (paTabDetail.urlDisplayCode == '2' || paTabDetail.urlDisplayCode == '3') {
          if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'pamemberMessaging-' + paCount).classList.contains('active')) {
            this.expandPATreeLeaf(paCount, paTabDetail,true);
          }
        }
        paCount++;
      }
    }

    if (this.qlTabDetails != null && this.qlTabDetails.length > 0) {
      let qlCount = 0;
      for (let qlTabDetail of this.qlTabDetails) {
        if (qlTabDetail.urlQLProgramDisplayCode == '1' || qlTabDetail.urlQLProgramDisplayCode == '3') {
          if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'quantityLimitAmount-' + qlCount).classList.contains('active')) {
            this.expandqlTreeLeaf(qlCount, qlTabDetail,true);
          }
        } else if (qlTabDetail.urlQLProgramDisplayCode == '2') {
          if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'qlmemberMessaging-' + qlCount).classList.contains('active')) {
            this.expandqlTreeLeaf(qlCount, qlTabDetail,true);
          }
        }
        qlCount++;
      }
    }

    if (this.acaTabDetails != null && this.acaTabDetails.length > 0) {
      for (let i = 0; i < this.acaTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'aca' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'aca', this.acaTabDetails[i],true);
        }
      }
    }

    if (this.ageTabDetails != null && this.ageTabDetails.length > 0) {
      for (let i = 0; i < this.ageTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'age' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'age', this.ageTabDetails[i],true);
        }
      }
    }
    
    if (this.code1TabDetails != null && this.code1TabDetails.length > 0) {
      for (let i = 0; i < this.code1TabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'code1' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'code1', this.code1TabDetails[i],true);
        }
      }
    }

    if (this.dlTabDetails != null && this.dlTabDetails.length > 0) {
      for (let i = 0; i < this.dlTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'dl' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'dl', this.dlTabDetails[i],true);
        }
      }
    }

    if (this.exdTabDetails != null && this.exdTabDetails.length > 0) {
      for (let i = 0; i < this.exdTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'exd' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'exd', this.exdTabDetails[i],true);
        }
      }
    }

    if (this.fffTabDetails != null && this.fffTabDetails.length > 0) {
      for (let i = 0; i < this.fffTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'fff' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'fff', this.fffTabDetails[i],true);
        }
      }
    }

    if (this.gapTabDetails != null && this.gapTabDetails.length > 0) {
      for (let i = 0; i < this.gapTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'gap' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'gap', this.gapTabDetails[i],true);
        }
      }
    }

    if (this.genderTabDetails != null && this.genderTabDetails.length > 0) {
      for (let i = 0; i < this.genderTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'gender' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'gender', this.genderTabDetails[i],true);
        }
      }
    }

    if (this.hcTabDetails != null && this.hcTabDetails.length > 0) {
      for (let i = 0; i < this.hcTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'hc' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'hc', this.hcTabDetails[i],true);
        }
      }
    }

    if (this.hiTabDetails != null && this.hiTabDetails.length > 0) {
      for (let i = 0; i < this.hiTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'hi' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'hi', this.hiTabDetails[i],true);
        }
      }
    }

    if (this.ispTabDetails != null && this.ispTabDetails.length > 0) {
      for (let i = 0; i < this.ispTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'isp' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'isp', this.ispTabDetails[i],true);
        }
      }
    }

    if (this.laTabDetails != null && this.laTabDetails.length > 0) {
      for (let i = 0; i < this.laTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'la' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'la', this.laTabDetails[i],true);
        }
      }
    }

    if (this.laoTabDetails != null && this.laoTabDetails.length > 0) {
      for (let i = 0; i < this.laoTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'lao' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'lao', this.laoTabDetails[i],true);
        }
      }
    }

    if (this.moTabDetails != null && this.moTabDetails.length > 0) {
      for (let i = 0; i < this.moTabDetails.length; i++) {
        // if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'mo' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          if (beforeOrAfter === 'AfterPrint' || !(document.getElementById(this.pIndex+"-"+'mo' + 'Detail-' + i).innerHTML == 'keyboard_arrow_down')) {
          
          this.expandOtherTreeLeaf(i, 'mo', this.moTabDetails[i],true);
        }
      }
    }

    if (this.maintanaceTabDetails != null && this.maintanaceTabDetails.length > 0) {
      for (let i = 0; i < this.maintanaceTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'maintanace' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'maintanace', this.maintanaceTabDetails[i],true);
        }
      }
    }

    if (this.npdTabDetails != null && this.npdTabDetails.length > 0) {
      for (let i = 0; i < this.npdTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'npd' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'npd', this.npdTabDetails[i],true);
        }
      }
    }

    if (this.ndsTabDetails != null && this.ndsTabDetails.length > 0) {
      for (let i = 0; i < this.ndsTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'nds' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'nds', this.ndsTabDetails[i],true);
        }
      }
    }

    if (this.oacTabDetails != null && this.oacTabDetails.length > 0) {
      for (let i = 0; i < this.oacTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'oac' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'oac', this.oacTabDetails[i],true);
        }
      }
    }

    if (this.otherTabDetails != null && this.otherTabDetails.length > 0) {
      for (let i = 0; i < this.otherTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'other' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'other', this.otherTabDetails[i],true);
        }
      }
    }

    if (this.otcTabDetails != null && this.otcTabDetails.length > 0) {
      for (let i = 0; i < this.otcTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'otc' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'otc', this.otcTabDetails[i],true);
        }
      }
    }

    if (this.partbTabDetails != null && this.partbTabDetails.length > 0) {
      for (let i = 0; i < this.partbTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'partb' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'partb', this.partbTabDetails[i],true);
        }
      }
    }

    if (this.pdTabDetails != null && this.pdTabDetails.length > 0) {
      for (let i = 0; i < this.pdTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'pd' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'pd', this.pdTabDetails[i],true);
        }
      }
    }

    if (this.pgTabDetails != null && this.pgTabDetails.length > 0) {
      for (let i = 0; i < this.pgTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'pg' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'pg', this.pgTabDetails[i],true);
        }
      }
    }

    if (this.rebateTabDetails != null && this.rebateTabDetails.length > 0) {
      for (let i = 0; i < this.rebateTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'rebate' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'rebate', this.rebateTabDetails[i],true);
        }
      }
    }
    if (this.saoTabDetails != null && this.saoTabDetails.length > 0) {
      for (let i = 0; i < this.saoTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'sao' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'sao', this.saoTabDetails[i],true);
        }
      }
    }

    if (this.spTabDetails != null && this.spTabDetails.length > 0) {
      for (let i = 0; i < this.spTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'sp' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'sp', this.spTabDetails[i],true);
        }
      }
    }
    if (this.vbidTabDetails != null && this.vbidTabDetails.length > 0) {
      for (let i = 0; i < this.vbidTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'vbid' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'vbid', this.vbidTabDetails[i],true);
        }
      }
    }
    if (this.siTabDetails != null && this.siTabDetails.length > 0) {
      for (let i = 0; i < this.siTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'si' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'si', this.siTabDetails[i],true);
        }
      }
    }
    if (this.partdTabDetails != null && this.partdTabDetails.length > 0) {
      for (let i = 0; i < this.partdTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'partd' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'partd', this.partdTabDetails[i],true);
        }
      }
    }
    if (this.zdvTabDetails != null && this.zdvTabDetails.length > 0) {
      for (let i = 0; i < this.zdvTabDetails.length; i++) {
        if (beforeOrAfter === 'AfterPrint' || !document.getElementById(this.pIndex+"-"+'zdv' + 'Detail-' + i).classList.contains('fa-angle-down')) {
          this.expandOtherTreeLeaf(i, 'zdv', this.zdvTabDetails[i],true);
        }
      }
    }

  }

  doCallBackFromAlternatives(drugSearchAlternative) {
    this.getDrugSearchDetailData1(drugSearchAlternative);
  }


  drugSearchDetailDataList = new Array<DrugSearchDetailData>();

  getDrugSearchDetailData1(validMatchingEntry: ValidMatchingEntry) {
    this.showDugSearchDetailData = false;
    this.showError = false;
    this.showAlertMessage = false;
    this.showAlternativeAlertMessage = false;
    validMatchingEntry.planDetails = this.planDetails;
    this.validMatchingEntry = validMatchingEntry;
    this.validMatchingEntryList = new Array<ValidMatchingEntry>();
    this.validMatchingEntryList.push(validMatchingEntry);
    this.subs.add(
      this._drugSearchURLService
        .getDrugSearchDetailData(this.validMatchingEntryList)
        .subscribe(
          (res) => {
            this.drugSearchDetailDataList = res.data;
            this.drugSearchDetailData = this.drugSearchDetailDataList[0];
            this.drugDetails = this.drugSearchDetailData.drugDetails;
            
            this._drugSearchURLService.setGlobalSubject(this.drugSearchDetailData);
          }
        )
    );
  }

 scrollHandler(event) {
    if (
      event.target.offsetHeight + event.target.scrollTop >=
      event.target.scrollHeight - 2 &&
      !this.stopScrollApiCall
    ) {
      this.offSet = this.offSet + this.limit;
      this.showAlternatives("scrollHandlerEvent");
    }
  }

  showAlternatives(eventFrom: string) {
    if(this.drugDetails != undefined) {
    this.tccDetails = this.drugDetails.tccDetails;
    this.tccAlternativeDetails = new Array<DrugSearchTCCDetails>();
    if (this.tccDetails.length > 0) {
      for (let tccVal of this.tccDetails) {
        this.tccDetail = new DrugSearchTCCDetails();
        this.tccDetail.groupId = tccVal.groupId;
        this.tccDetail.therCat1Nm = tccVal.therCat1Nm;
        this.tccDetail.therClass1Nm = tccVal.therClass1Nm;
        this.tccAlternativeDetails.push(this.tccDetail);
      }
    }
    this.drugSearchCriteria.tccDetails = this.tccAlternativeDetails;
  }
    this.showAlternativeAlertMessage = false;
    if (this.planDetails?.drugSearchType === 'searchByDrugClass') {
      this.drugSearchCriteria.customerSetId = this.planDetails.customerSetId;
      this.drugSearchCriteria.formularyPackageId = this.planDetails.packageId;
      this.drugSearchCriteria.formularyPackageDate = this.planDetails.lastPublicationDate;
      this.drugSearchCriteria.reasonNotPricedDisplay = this.planDetails.reasonNotPricedDisplay;
      this.drugSearchCriteria.obsoleteDrugDisplay = this.planDetails.obsoleteDrugDisplay;
      this.drugSearchCriteria.repackagersDisplay = this.planDetails.repackagersDisplay;
      this.drugSearchCriteria.otcDrugDisplay = this.planDetails.otcDrugDisplay;
      this.drugSearchCriteria.fileEventId = this.planDetails.fileEventId;
      this.drugSearchCriteria.level = 'label name';
      this.drugSearchCriteria.drugListId = this.planDetails.drugListId;
      this.drugSearchCriteria.planId = this.planDetails.planId;
    }else{
      this.drugSearchCriteria.customerSetId = this.planDetails.customerSetId;
      this.drugSearchCriteria.formularyPackageId = this.planDetails.packageId;
      this.drugSearchCriteria.formularyPackageDate = this.planDetails.lastPublicationDate;
      this.drugSearchCriteria.reasonNotPricedDisplay = this.planDetails.reasonNotPricedDisplay;
      this.drugSearchCriteria.obsoleteDrugDisplay = this.planDetails.obsoleteDrugDisplay;
      this.drugSearchCriteria.repackagersDisplay = this.planDetails.repackagersDisplay;
      this.drugSearchCriteria.otcDrugDisplay = this.planDetails.otcDrugDisplay;
      this.drugSearchCriteria.fileEventId = this.planDetails.fileEventId;
      this.drugSearchCriteria.drugListId = this.planDetails.drugListId;
      this.drugSearchCriteria.planId = this.planDetails.planId;
    }
    this.drugSearchCriteria.value = this.drugSearchDetailData.drugSearchMatchingEntry.labelName;
    this.drugSearchCriteria.gcnId = this.drugSearchDetailData.drugSearchMatchingEntry.gcnId;
    this.drugSearchCriteria.gcnSequenceNumber = this.drugSearchDetailData.drugSearchMatchingEntry.gcnSequenceNumber;
    this.drugSearchCriteria.tierValueCount = this.drugSearchDetailData.drugSearchMatchingEntry.tierValueCount;
    this.drugSearchCriteria.selectedLabelName = this.drugSearchDetailData.drugSearchMatchingEntry.labelName;

    this.drugSearchCriteria.classBrandOrGeneric = this.isBrandOrGeneric;
    if (eventFrom === "btnEvent") {
      this.limit = 20;
      this.offSet = 0;
      this.validMatchingEntryList = new Array<ValidMatchingEntry>();
    }
    this.drugSearchCriteria.limit = this.limit;
    this.drugSearchCriteria.offset = this.offSet;
    this.alternativeErrorMessage = false;
    this.subs.add(
      this._drugSearchURLService.getAlternatives(this.drugSearchCriteria).subscribe((res) => {
        this.alternativeErrorMessage = false;
       // this.validMatchingEntryList = new Array<ValidMatchingEntry>();
       this.validMatchingEntryList.push(...res.data);
        if(this.validMatchingEntryList && this.validMatchingEntryList.length == 0  ) {
          this.alternativeErrorMessage = true;
        }
        res.data.length < this.limit
                ? (this.stopScrollApiCall = true)
                : (this.stopScrollApiCall = false);
        this.showAlternativesPopUp = true;
        if (eventFrom === "btnEvent") {
        this.open(this.alternativesmodal);
        }
      }));
  }


  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  close() {
    this.showAlternativeAlertMessage = false;
  }

}
